<div
  class="flex flex-column align-items-center justify-content-center w-full h-full gap-6"
>
  <p-card [style]="{ maxWidth: '25rem', width: '100%', overflow: 'hidden' }">
    <ng-template #header>
      <div class="flex justify-content-center py-6 px-4 bg-white">
        <app-responsive-logo path="assets/images/logo-md.svg" />
      </div>
    </ng-template>
    <ng-template #title> {{ 'LOGIN.WELCOME' | translate }} </ng-template>
    <ng-template #footer>
      <div class="flex gap-4 mt-1">
        <p-button
          label="{{ 'LOGIN.LOGIN_BUTTON' | translate }}"
          styleClass="w-full"
          class="w-full"
          (click)="login()"
        >
          <ng-template #icon>
            <div class="flex align-items-center login-icon">
              <img height="20" src="assets/images/okta.png" alt="OKTA logo" />
            </div>
          </ng-template>
        </p-button>
      </div>
    </ng-template>
  </p-card>
</div>
